<template>
  <div class="compression-check">
    <div class="first-row">
      <div class="el-input-group el-input-group--prepend">
        <div v-if="warnings.length" class="el-input-group__prepend">
          <help-tooltip type="warning">
            <span v-for="warning in warnings" :key="warning.message">
              {{ warning.message }}
              <br>
            </span>
          </help-tooltip>
        </div>
        <el-select
          v-close-on-zoom
          :value="checkType"
          :disabled="readonly"
          class="current-select"
          @input="value => updateCheckType(value)"
        >
          <el-option :value="'HAVE_BEEN_ADMIN'" :label="'Have compressions been administered'" />
          <el-option :value="'HAVE_STOPPED'" :label="'Have compressions been stopped'" />
          <el-option :value="'ARE_BEING_ADMIN'" :label="'Are compressions being administered'" />
        </el-select>
      </div>
    </div>
    <div class="second-row">
      <el-input
        v-integer-only
        type="number"
        :value="state.range.min"
        :disabled="readonly || state.haveStopped"
        placeholder="any"
        class="range-input range-input-min"
        min="0"
        max="200"
        @change="min => updateRange({min: parseInt(min)})"
      >
        <template slot="prepend">between</template>
      </el-input>

      <el-input
        v-integer-only
        type="number"
        :value="state.range.max"
        :disabled="readonly || state.haveStopped"
        placeholder="any"
        class="range-input range-input-max"
        min="0"
        max="200"
        @change="max => updateRange({max: parseInt(max)})"
      >
        <template slot="prepend">and</template>
        <template slot="append">CPM</template>
      </el-input>
    </div>
  </div>
</template>

<script>
import { get, isUndefined, uniqBy } from 'lodash';

import HelpTooltip from '~lib/common/components/HelpTooltip';

export default {
  name: 'compression-check',
  components: {
    HelpTooltip,
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      defaultRange: { min: 1, max: 200 },
      state: {
        isCurrent: false,
        haveStopped: false,
        range: { min: null, max: null },
      },
    };
  },
  computed: {
    checkType() {
      if (this.state.isCurrent) {
        return 'ARE_BEING_ADMIN';
      } else {
        if (this.state.haveStopped) {
          return 'HAVE_STOPPED';
        } else {
          return 'HAVE_BEEN_ADMIN';
        }
      }
    },
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      const warnings = get(
        this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(warning => warning.metadata && warning.metadata.checkKey === this.ikey);

      return uniqBy(warnings, 'message');
    },
  },
  beforeMount() {
    const data = this.getData(this.ikey);
    this.state.isCurrent = isUndefined(data, 'isCurrent') ? false : data.isCurrent;
    this.state.haveStopped = isUndefined(data, 'haveStopped') ? false : data.haveStopped;
    this.state.range = get(data, 'range') || this.defaultRange;
    this.update();
  },
  methods: {
    updateCheckType(value) {
      // if switching away from have stopped, apply default range
      if (this.state.haveStopped && value !== 'HAVE_STOPPED') {
        this.state.range = this.defaultRange;
      }
      if (value === 'ARE_BEING_ADMIN') {
        this.state.isCurrent = true;
        this.state.haveStopped = false;
      }
      else if (value === 'HAVE_STOPPED') {
        this.state.isCurrent = false;
        this.state.haveStopped = true;
        this.state.range = { min: 0, max: 0 };
      }
      else if (value === 'HAVE_BEEN_ADMIN') {
        this.state.isCurrent = false;
        this.state.haveStopped = false;
      }
      this.update();
    },
    updateRange(updates) {
      this.state.range = {
        ...this.state.range,
        ...updates,
      };
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'COMPRESSION_ADMINISTERED',
        id: 'CPR',
        isCurrent: this.state.isCurrent,
        haveStopped: this.state.haveStopped,
        range: this.state.range,
        operator: 'ADMINISTERED',
        value: true,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.range-input {
  width: auto;
}

.compression-check {
  display: flex;
  flex-direction: column;
}

.first-row {
  display: flex;
}

.current-select {
  flex: 1;
  width: 100%;
}

.second-row {
  display: flex;
}

</style>
